import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const EditIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path 
                fillRule="evenodd" 
                d="M19.47 4.457a2.122 2.122 0 0 0-3 0L14.066 6.86l2.965 2.965 2.416-2.345c.85-.825.86-2.185.022-3.023ZM4.83 16.096l8.529-8.53 2.955 2.956-8.651 8.401-3.219.387.386-3.214ZM15.762 3.75a3.122 3.122 0 1 1 4.382 4.447L8.24 19.758a.5.5 0 0 1-.289.138l-4.017.482a.5.5 0 0 1-.556-.556l.482-4.017a.5.5 0 0 1 .143-.294l11.76-11.76ZM11.5 20a.5.5 0 1 0 0 1h8a.5.5 0 0 0 0-1h-8Z" 
                clipRule="evenodd"
            />
        </SvgIcon>
    )
}

export default EditIcon